import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { FieldLayout } from 'app/components/core/FieldLayout';
import { Loading, LoadingSize } from 'app/components/core/Loading';
import * as styles from './Fieldset.css';

const cx = classnames.bind(styles);

export function Fieldset({
    testId,
    className,
    label,
    children,
    direction,
    isProcessing = false,
    ...props
}) {
    const classes = cx('base', className);

    const fieldLayoutProps = {
        ...(direction && { direction })
    };

    return (
        <fieldset data-testid={testId} className={classes} {...props}>
            {label && (
                <legend className={styles.label}>
                    {label} {isProcessing && <Loading size={LoadingSize.EXTRA_SMALL} />}
                </legend>
            )}
            <FieldLayout {...fieldLayoutProps}>{children}</FieldLayout>
        </fieldset>
    );
}

Fieldset.propTypes = {
    /**
     * Emit a `data-testid` prop on the root element of the component. Use this
     * to help automated testing tools find this particular component.
     */
    testId: PropTypes.string,

    /**
     * Set additional CSS classes on the component to extend the default styles.
     */
    className: PropTypes.string,

    /**
     * Label for the fieldset.
     */
    label: PropTypes.string,

    /**
     * Direction for FieldLayout.
     */
    direction: PropTypes.string,

    /**
     * Show a loading icon when the fieldset is fetching or processing data.
     */
    isProcessing: PropTypes.bool,

    /**
     * Fieldset contents. Rendered adjacent to the fieldset legend.
     */
    children: PropTypes.node
};
